import { cn } from "@app/lib/utils";
import { trans } from "@mongez/localization";

interface SectionTitleProps {
  isVisible: boolean;
}

export function SectionTitle({ isVisible }: SectionTitleProps) {
  return (
    <h3
      className={cn(
        "absolute min-w-full text-center left-1/2 top-1/2 z-30 -translate-x-1/2 -translate-y-1/2 text-[96px] font-bold text-white transition-opacity duration-500 max-lg:text-4xl",
        isVisible ? "visible opacity-100" : "invisible opacity-0",
      )}
    >
      {trans("ourSectors.title")}
    </h3>
  );
}
